import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import store from "./state";
import AppRouter from "./router/app-router";

import "./main.css";

/* eslint-disable react/jsx-filename-extension */
render(
  <Provider store={store}>
    <AppRouter />
  </Provider>,
  document.querySelector("#root")
);
/* eslint-enable react/jsx-filename-extension */

// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js